module.exports = __webpack_public_path__ + "img/ERGO_Icon_black_Laptop.3d6d300e.svg";